<template>
    <div class="w-full flex flex-row w-full justify-center ">
        <div v-if="fis" class="flex flex-col mn3-content rounded-sm border">
            <div v-for="fi in fis" :key="fi.id"
             :class="`${viewingMembersOf != -1 && viewingMembersOf != fi.id ? 'hidden' : ''} flex flex-row justify-between gap-x-5 px-2 py-5 border-b`">
             <span class="flex flex-col">
                <span class="font-bold">{{fi.attributes.title}}</span>
                <span class="font-mono">ID {{fi.id.split('/')[1]}}</span>
                </span>
                <div class="flex flex-col w-48">
                    <div @click="router.push('settings?id=' + fi.id.split('/')[1])" class="cursor-pointer px-2 py-1 rounded mn3-button mb-1 flex flex-row justify-between items-center">
                        <Icon id="cog" class="h-4 w-4 mr-2"/>
                        <p>FI Settings</p>
                    </div>
                    <div @click="exploreFI(fi.id)" class="cursor-pointer px-2 py-1 rounded mn3-button mb-1 flex flex-row justify-between items-center">
                        <Icon id="pc" class="h-4 w-4 mr-2"/>
                        <p>Login as FI Admin</p>
                    </div>
                </div>
            </div>
        </div>



        <transition name="fade">
            <div v-if="chatOpen" class="flex flex-col max-w-screen-lg w-full">
                <Chat 
                    @close="chatOpen = false;focusedId = -1;"
                    :messages="members[0].messages"
                    :withName="members[0].name" />
            </div>
        </transition>
    </div>
</template>

<script>
    import { ref } from 'vue'

	import Button from "@/components/Button.vue";
	import Chat from "@/components/Chat.vue";
	import Form from "@/components/Form.vue";
	import Icon from "@/components/Icon.vue";
	import Field from "@/components/Field.vue";
    import { useRouter } from "vue-router"

	export default {
		components:{
            Chat,
            Button,
			Form,
			Field,
            Icon
		},
		data(){
			return {
			};
		},
        computed: {
        },
        methods: {            
            async exploreFI(fiIdFull){
                //Get member id # from full
                let fiId = fiIdFull.split('/')[1]
                window.open(`https://${window.location.hostname}/api/amiadmin-sso/${fiId}`);
            },
            async fetchSelf(fi){
                let fetched = await this.$rapi.get(fi.links.self);
                console.log('fetchSelf: ', fetched);
            },
            async fetchFIs(){
                let moreToFetch = true;
                let fetchUrl = "fis";
                this.fis = [];
                do{
                    let fetched = await this.$rapi.get(fetchUrl);
                    this.fis.push(...fetched['data']['data']);
                    console.log('fetchTest: ', this.fis);
                        
                    if(fetched.data.links && fetched.data.links.next){
                        fetchUrl = fetched.data.links.next;
                    }
                    else{
                        moreToFetch = false;
                    }
                }while(moreToFetch);
            }
        },
		created(){
            document.title = 'FI List'
            this.fetchFIs()
		}, 

        setup(){
            const viewingMembersOf = ref(-1)
            const members = ref([])
            const viewMode = ref("large")
            const focusedMode = ref("");
            const chatOpen = ref(false);
            const focusedId = ref(-1)
            const quickFilterVal = ref("")
            const router = useRouter();
            const fis = ref([])
            const activeConvo = ref(1);
            const convos = ref([
                {
                    id: 1,
                    title: 'Login issue 3',
                    lastActivity: '08/07/2022',
                    awaitingReply: true
                },
                {
                    id: 2,
                    title: 'Login issue 2',
                    lastActivity: '08/04/2022',
                    awaitingReply: false
                },
                {
                    id: 3,
                    title: 'Login issue',
                    lastActivity: '08/01/2022',
                    awaitingReply: true
                }
            ]);

            function loginAsUser(){
                window.open('')
            }


function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

            return { 
                numberWithCommas,
                loginAsUser,
                chatOpen,
                fis,
                quickFilterVal,
                focusedId,
                focusedMode,
                convos,
                activeConvo,
                members,
                viewMode,
                router,
                viewingMembersOf

             }

        }
	}
	
</script>
